import React from "react";
import "./Stats.css";

const Stats = () => {
  return (
    <section id="stats" className="stats section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">

          <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
            <i className="bi-person-fill-check"></i>
            <div className="stats-item">
              <span>5000+</span>
              <p>Trained People</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
            <i className="bi-youtube"></i>
            <div className="stats-item">
              <span>500+</span>
              <p>Webinars and Workshops</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
            <i className="bi-calendar4-event"></i>
            <div className="stats-item">
              <span>30+</span>
              <p>Offline Summits and Events</p>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
            <i className="bi-trophy"></i>
            <div className="stats-item">
              <span>11</span>
              <p>World Record Holder</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Stats;
